module.exports = __webpack_public_path__ + "static/media/LogoSelo.c3377c5b.svg";